var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3671B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.035 32.0593L20.7917 22.94L19.625 32.0714L17.035 32.0593ZM27.2083 22.9521L30.965 32.0714L28.375 32.0714L27.2083 22.9521ZM13.5 34.4879L21.6667 34.5L24 16.2857L26.3333 34.5L34.5 34.4879L24 9L13.5 34.4879Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7c794143bc6c1eac3b7c9fdeb6a1aab2.svg";
export { ForwardRef as ReactComponent };